import { LanConnectIcon } from './LanConnectIcon';

/**
 * author: Simran
 * id B52D6944-3AC2-4113-A91C-199C0CD577A6
 * name lan-connect
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lan-connect.svg
 * tags
 */
export const LocalAreaNetworkConnectIcon = LanConnectIcon;
export default LocalAreaNetworkConnectIcon